import { render, staticRenderFns } from "./CobDasboardDrillProject.vue?vue&type=template&id=3f663506&"
import script from "./CobDasboardDrillProject.vue?vue&type=script&lang=js&"
export * from "./CobDasboardDrillProject.vue?vue&type=script&lang=js&"
import style0 from "./CobDasboardDrillProject.vue?vue&type=style&index=0&id=3f663506&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports